import { Reducer } from 'redux'
import { ConfigState, ConfigActionTypes } from './type'

const initialState: ConfigState = {
  channelSource: '',  //默认的渠道为小程序
  bannerList: [],
  userInfo: {
    accountPhone: '',
    userDomain: {userHeadPortrait:''}
  },
  homePopups: [],
  footerBannerList:[],
  personCenterBannerList:[],
  servpackBannerList:[],
  isHomePopupsWithLogin: false,
  showAddWechat: false,
}

const reducer: Reducer<ConfigState> = (state = initialState, action) => {
  switch (action.type) {
  case ConfigActionTypes.FETCH_CHANNEL_CONFIG_SUCCESS: {
    return {
      ...state,
      channelSource: action.channelSource,
    }
  }
  case ConfigActionTypes.FETCH_BANNER_SUCCESS: {
    const { data={} } = action;
    return {
      ...state,
      ...data,
    }
  }
  case ConfigActionTypes.FETCH_USERINFO_SUCCESS: {
    const { data = {} } = action;
    return {
      ...state,
      userInfo: data,
    }
  }
  case ConfigActionTypes.FETCH_ADDWECHATRESOURCES_SUCCESS: {
    const { data = {} } = action;
    return {
      ...state,
      ...data,
    }
  }
  default: {
    return state
  }
  }
}

export { reducer as ConfigReducer };
